<template>
  <div>
    <ol class="scene-list"><li v-for="(id, index) in state.order" :key="id">
      <span class="scene-number">{{ index + 1 }}</span><MediaPlaceholder :material="scene(id)" />
      <div><button class="secondary" :disabled="disabled || index === 0" :aria-label="`Move ${scene(id).label} up`" @click="$emit('action', { type: 'sequence_move', index, direction: -1 })">↑ Up</button><button class="secondary" :disabled="disabled || index === state.order.length - 1" :aria-label="`Move ${scene(id).label} down`" @click="$emit('action', { type: 'sequence_move', index, direction: 1 })">↓ Down</button></div>
    </li></ol>
    <p class="placeholder-note">The real scenes and correct order have not been selected. Your order will be saved without a correctness score.</p>
  </div>
</template>
<script>
import MediaPlaceholder from './MediaPlaceholder.vue';
export default { components: { MediaPlaceholder }, props: { stage: Object, state: Object, disabled: Boolean }, emits: ['action'], methods: { scene(id) { return this.stage.scenes.find(scene => scene.id === id); } } };
</script>
